import MailingListForm from 'components/forms/MailingListForm';
import Layout from 'components/home/Layout';
import SEO from 'components/home/SEO';

const MailingList: React.FC = () => {
  return (
    <>
      <SEO prefix="Subscribe" />
      <Layout>
        <div className="flex flex-col min-h-screen bg-gray-50">
          <div className="mx-4 mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="mt-24 text-center">
              <h2 className="mt-6 text-3xl font-extrabold text-center text-gray-900">
                Subscribe for updates
              </h2>
              <div className="text-left mt-2 text-gray-600 text-md">
                <p>
                  We are hard at work building and validating the solution to
                  improve how company&apos;s interpret their service
                  performance.
                </p>
                <p className="mt-2">
                  View{' '}
                  <a
                    className="text-summer-green-700"
                    href="https://docs.latencylingo.com/docs/intro"
                    target="_blank"
                    rel="noreferrer"
                  >
                    our documentation
                  </a>{' '}
                  to learn and start publishing performance reports.
                </p>
                <p className="mt-2">
                  Subscribe and we will keep you informed as we launch.
                </p>
              </div>
            </div>
            <div className="px-4 py-8 mt-8 bg-white rounded-lg shadow-lg sm:px-10">
              <MailingListForm />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default MailingList;
